import { Link, useLocation } from "react-router-dom";
import { Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { NAV, SERVICES } from "../lib/content";
import { INSTAGRAM_URL, WHATSAPP, waLink, handleAnchor, EMAIL } from "../lib/site";
import { Wordmark } from "./JLMark";

export const Footer = () => {
  const { pathname } = useLocation();
  const home = pathname === "/";
  const anchor = (id) => ({ href: home ? `#${id}` : `/#${id}`, onClick: home ? (e) => handleAnchor(e, id) : undefined });

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#06080E] pt-20">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 md:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Wordmark />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-300">Criação de sites profissionais, modernos e estratégicos para comércios, empresas e empreendedores.</p>
          <div className="mt-6 flex gap-3">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram da JL Nexus" data-testid="footer-instagram-link" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#00C8FF]"><Instagram className="h-5 w-5" /></a>
            {WHATSAPP && (
              <a href={waLink("Olá, JL Nexus!")} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp da JL Nexus" data-testid="footer-whatsapp-link" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#00C8FF]"><MessageCircle className="h-5 w-5" /></a>
            )}
          </div>
        </div>
        <div className="lg:col-span-2">
          <p className="font-mono-jl text-xs uppercase tracking-[0.25em] text-[#7FE3FF]">Navegação</p>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV.map((n) => <li key={n.id}><a {...anchor(n.id)} data-testid={`footer-link-${n.id}`} className="text-slate-300 transition-colors hover:text-white">{n.label}</a></li>)}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono-jl text-xs uppercase tracking-[0.25em] text-[#7FE3FF]">Serviços</p>
          <ul className="mt-5 space-y-3 text-sm">
            {SERVICES.map((s) => <li key={s.title}><a {...anchor("servicos")} className="text-slate-300 transition-colors hover:text-white">{s.title}</a></li>)}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono-jl text-xs uppercase tracking-[0.25em] text-[#7FE3FF]">Contato</p>
          <a {...anchor("contato")} data-testid="footer-contact-button" className="group mt-5 inline-flex items-center gap-2 rounded-full bg-[#087BFF] px-5 py-3 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5">
            Solicitar orçamento <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </a>
          <ul className="mt-6 space-y-3 text-sm">
            <li><a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="text-slate-300 transition-colors hover:text-white">{EMAIL}</a></li>
            <li><Link to="/privacidade" data-testid="footer-privacy-link" className="text-slate-300 transition-colors hover:text-white">Política de privacidade</Link></li>
          </ul>
        </div>
      </div>

      <div data-testid="footer-banner" className="mt-16">
        <img src={`${process.env.PUBLIC_URL}/img/banner.webp`} alt="JL Nexus Soluções Digitais — Mais que sites. Conexões que geram resultados." loading="lazy" className="w-full object-cover" />
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-5 py-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p data-testid="footer-tagline">JL Nexus — Mais que sites, conexões que geram resultados.</p>
          <p data-testid="footer-copyright">© {new Date().getFullYear()} JL Nexus. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};
